export default {
  title_one: '{{count}} opties verwijderen?',
  title_other: '{{count}} opties verwijderen?',
  description: '<strong>{{items}}</strong> wordt van het menu verwijderd',
  buttons: {
    yes: 'Ja',
    no: 'Nee',
  },
  toasts: {
    failed_to_delete_modifier_one: 'Verwijderen van optie mislukt',
    failed_to_delete_modifier_other: 'Verwijderen van opties mislukt',
    modifiers_got_deleted_one: 'Optie is verwijderd',
    modifiers_got_deleted_other: 'Opties zijn verwijderd',
  },
};
